import { IStudentProfileDetailContainerDispatch } from "utils/interfaces/student-profile-details";
import StudentProfileDetailComponent, {
  StudentProfileDetailProps,
} from "pages/StudentProfileDetails";
import { connect, MapDispatchToProps } from "react-redux";
import {
  enrollmentAndAttendanceHistoryListRequest,
  studentDetailsRequest,
} from "store/student/action";
import { IStudentDetails } from "utils/interfaces/student";
import {
  allocatePLARequest,
  deferSLPRequest,
  getAuditTrailListRequest,
  getContactNoteRequest,
  deleteCompletedSLPRequest,
  nextOrCurrentSLPRequest,
  updateContactDateRequest,
} from "store/studentProfileDetails/actions";
import {
  plaUserListRequest,
  updateSLPContactNoteRequest,
  updateSLPContactProgressRequest,
  updateSLPParticipationRequest,
  completedSLPListRequest,
} from "store/slpDashboard/actions";

const mapDispatchToProps: MapDispatchToProps<
  IStudentProfileDetailContainerDispatch,
  IStudentDetails
> = {
  studentDetailsRequest,
  enrollmentAndAttendanceHistoryListRequest,
  nextOrCurrentSLPRequest,
  deferSLPRequest,
  plaUserListRequest,
  allocatePLARequest,
  getContactNoteRequest,
  updateSLPContactNoteRequest,
  getAuditTrailListRequest,
  updateSLPParticipationRequest,
  updateSLPContactProgressRequest,
  completedSLPListRequest,
  deleteCompletedSLPRequest,
  updateContactDateRequest,
};

const connector = connect(null, mapDispatchToProps);
const StudentProfileDetails: React.FC<StudentProfileDetailProps> = (props) => {
  return <StudentProfileDetailComponent {...props} />;
};

export default connector(StudentProfileDetails);
